/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ArrowDownIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M12 2a1 1 0 0 1 1 1v15.586l5.793-5.793a1 1 0 0 1 1.414 1.414l-7.5 7.5a1 1 0 0 1-1.414 0l-7.5-7.5a1 1 0 1 1 1.414-1.414L11 18.586V3a1 1 0 0 1 1-1" clipRule="evenodd" /></svg>;
};
export default ArrowDownIcon;